const translations = {
  en: {
    nav: {
      badge: 'Full Stack Developer',
      home: 'Home',
      about: 'About',
      services: 'Services',
      skills: 'Skills',
      education: 'Education',
      projects: 'Projects',
      community: 'Community',
      contact: 'Contact',
    },
    hero: {
      greeting: "Hi, I'm",
      subtitle: "Full Stack Developer & Master's Student in Computer Vision — USTHB",
      desc1: 'Crafting complete web solutions across',
      domain1: 'Frontend Development',
      domain2: 'Backend Development',
      domain3: 'Database Design',
      domain4: 'API Development',
      domain5: 'Deployment',
      domain6: 'Software Architecture',
      downloadCV: 'Download CV',
      downloadResume: 'Download Resume',
    },
    about: {
      sectionLabel: 'About Me',
      headline1: 'Full-Stack Development',
      headline2: '& Computer Vision',
      p1: "I'm Amine — a Computer Science graduate from USTHB, currently pursuing a Master's degree in Computer Vision. I work at the intersection of AI research and full-stack web development: building intelligent systems and shipping real web products that clients actually use.",
      p3: "I've built CNN-based fire detection systems, face anti-spoofing pipelines with PCA and SVM, document scanners with OpenCV, and delivered client websites for companies in Algeria and France. I write clean code and I care about making things that work well, not just look good.",
      stat1: 'Projects Delivered',
      stat2: 'Years Experience',
      stat3: 'Tech Stacks',
    },
    services: {
      sectionLabel: 'What I Do',
      headline: 'Professional Services',
      subheadline: 'Creating development solutions that match your exact requirements',
      learnMore: 'Learn More',
      items: [
        {
          icon: '🖥️',
          title: 'Full Stack Web Applications',
          description: 'Building complete end-to-end web applications — from user interface to server logic, database, and deployment.',
          features: ['React & Next.js Frontend', 'Node.js / Express Backend', 'Database Integration', 'End-to-End Architecture'],
          color: 'from-emerald-500 to-teal-500',
        },
        {
          icon: '⚙️',
          title: 'Backend & API Development',
          description: 'Designing secure, scalable, and well-documented APIs with robust and maintainable server-side architecture.',
          features: ['REST API Design', 'Authentication & Security', 'Node.js / Express / FastAPI', 'Performance Optimization'],
          color: 'from-blue-500 to-cyan-500',
        },
        {
          icon: '🗄️',
          title: 'Database & Cloud Solutions',
          description: 'Designing, optimizing, and managing relational and NoSQL databases with reliable cloud deployment.',
          features: ['PostgreSQL & MySQL', 'Firebase & Supabase', 'Cloud Deployment', 'Data Modeling & Optimization'],
          color: 'from-purple-500 to-indigo-500',
        },
        {
          icon: '🎨',
          title: 'UI/UX Modern Interfaces',
          description: 'Crafting modern, responsive, and accessible interfaces with a strong focus on user experience and design.',
          features: ['Responsive Design', 'Tailwind CSS & Modern UI', 'Animations & Transitions', 'Mobile-First Approach'],
          color: 'from-orange-500 to-pink-500',
        },
        {
          icon: '🤖',
          title: 'AI Models & Computer Vision',
          description: 'Building and integrating intelligent AI systems — computer vision pipelines, deep learning models, and smart automation tools.',
          features: ['Computer Vision Pipelines', 'CNN & Deep Learning', 'PyTorch & OpenCV', 'AI Integration in Web Apps'],
          color: 'from-violet-500 to-purple-600',
        },
      ],
    },
    skills: {
      sectionLabel: 'Technical Expertise',
      headline1: 'Skills &',
      headline2: 'Technologies',
      subheadline: 'A focused toolkit for building intelligent systems and complete web applications.',
      categories: {
        languages: {
          title: 'Languages',
          description: 'Core languages used across software, web and AI projects.',
        },
        ai: {
          title: 'AI & Computer Vision',
          description: 'Designing image-processing pipelines and machine-learning solutions from experimentation to evaluation.',
        },
        frontend: {
          title: 'Frontend',
          description: 'Building responsive, accessible and polished user interfaces.',
        },
        backend: {
          title: 'Backend & Data',
          description: 'Creating reliable APIs and structured data layers for web products.',
        },
        tools: {
          title: 'Tools & Workflow',
          description: 'A practical environment for development, prototyping and collaboration.',
        },
      },
    },
    education: {
      sectionLabel: 'Education',
      headline1: 'Academic',
      headline2: 'Background',
      current: 'Current',
      coursework: 'Coursework',
    },
    projects: {
      sectionLabel: 'Portfolio',
      headline1: 'Featured',
      headline2: 'Projects',
      subheadline: 'A showcase of real work — from client websites to AI systems',
      liveDemo: 'Live Demo',
      githubRepo: 'GitHub Repo',
    },
    community: {
      sectionLabel: 'Community & Links',
      headline1: 'Connect With',
      headline2: 'Me',
      links: [
        { title: 'GitHub', description: 'Check out my open-source projects, contributions, and code repositories.' },
        { title: 'LinkedIn', description: 'Connect with me professionally, view my experience and network.' },
        { title: 'Email', description: 'Reach out for collaborations, opportunities, or just to say hi.' },
      ],
      visit: 'Visit',
    },
    contact: {
      sectionLabel: 'Contact',
      headline1: 'Have a',
      headline2: 'Project in Mind?',
      subheadline: "Let's build something great together.",
      sideHeadline1: "Let's Build Something",
      sideHeadline2: 'Amazing',
      sideP: "I'm always open to new opportunities — collaborations, internships, or full-time positions. If you have a project or just want to talk, feel free to reach out.",
      labelEmail: 'Email',
      labelPhone: 'Phone',
      labelLocation: 'Location',
      formName: 'Name',
      formNamePh: 'Your full name',
      formEmail: 'Email',
      formEmailPh: 'your.email@example.com',
      formMessage: 'Message',
      formMessagePh: 'Tell me about your project or opportunity...',
      send: 'Send Message',
      sending: 'Sending...',
      success: "Message sent successfully! I'll get back to you soon.",
      error: 'Failed to send message. Please try again or contact me directly.',
    },
    footer: {
      copyright: '© 2025 Amine Sellami. Built with React & care.',
    },
  },

  fr: {
    nav: {
      badge: 'Développeur Full Stack',
      home: 'Accueil',
      about: 'À propos',
      services: 'Services',
      skills: 'Compétences',
      education: 'Formation',
      projects: 'Projets',
      community: 'Communauté',
      contact: 'Contact',
    },
    hero: {
      greeting: 'Bonjour, je suis',
      subtitle: 'Développeur Full Stack & Étudiant en Master Vision par Ordinateur — USTHB',
      desc1: 'Développement de solutions web complètes couvrant le',
      domain1: 'Développement Frontend',
      domain2: 'Développement Backend',
      domain3: 'Conception de BDD',
      domain4: "Développement d'API",
      domain5: 'Déploiement',
      domain6: 'Architecture Logicielle',
      downloadCV: 'Télécharger CV',
      downloadResume: 'Télécharger Resume',
    },
    about: {
      sectionLabel: 'À propos de moi',
      headline1: 'Développement Full-Stack',
      headline2: '& Vision par Ordinateur',
      p1: "Je suis Amine — diplômé en Informatique de l'USTHB, actuellement en Master Vision par Ordinateur. Je travaille à l'intersection de la recherche en IA et du développement web full-stack : je construis des systèmes intelligents et des produits web réels que les clients utilisent vraiment.",
      p3: "J'ai développé des systèmes de détection d'incendie par CNN, des pipelines anti-spoofing avec PCA et SVM, des scanners de documents avec OpenCV, et livré des sites web clients pour des entreprises en Algérie et en France. J'écris du code propre et je m'assure que ce que je construis fonctionne bien, pas juste que ça ait l'air bien.",
      stat1: 'Projets Livrés',
      stat2: "Ans d'Expérience",
      stat3: 'Stacks Maîtrisés',
    },
    services: {
      sectionLabel: 'Ce que je fais',
      headline: 'Services Professionnels',
      subheadline: 'Des solutions de développement adaptées à vos besoins exacts',
      learnMore: 'En savoir plus',
      items: [
        {
          icon: '🖥️',
          title: 'Applications Web Full Stack',
          description: "Développement d'applications web complètes de bout en bout — de l'interface utilisateur à la logique serveur, la base de données et le déploiement.",
          features: ['Frontend React & Next.js', 'Backend Node.js / Express', 'Intégration Base de Données', 'Architecture End-to-End'],
          color: 'from-emerald-500 to-teal-500',
        },
        {
          icon: '⚙️',
          title: 'Backend & Développement API',
          description: "Conception d'API sécurisées, scalables et bien documentées avec une architecture serveur robuste et maintenable.",
          features: ['Conception REST API', 'Authentification & Sécurité', 'Node.js / Express / FastAPI', 'Optimisation des Performances'],
          color: 'from-blue-500 to-cyan-500',
        },
        {
          icon: '🗄️',
          title: 'Bases de Données & Cloud',
          description: 'Conception, optimisation et gestion de bases de données relationnelles et NoSQL avec un déploiement cloud fiable.',
          features: ['PostgreSQL & MySQL', 'Firebase & Supabase', 'Déploiement Cloud', 'Modélisation & Optimisation'],
          color: 'from-purple-500 to-indigo-500',
        },
        {
          icon: '🎨',
          title: 'Interfaces UI/UX Modernes',
          description: "Création d'interfaces modernes, responsives et accessibles avec une forte attention portée à l'expérience utilisateur.",
          features: ['Design Responsive', 'Tailwind CSS & UI Moderne', 'Animations & Transitions', 'Approche Mobile-First'],
          color: 'from-orange-500 to-pink-500',
        },
        {
          icon: '🤖',
          title: 'Modèles IA & Vision par Ordinateur',
          description: "Développement et intégration de systèmes IA intelligents — pipelines de vision par ordinateur, modèles de deep learning et outils d'automatisation.",
          features: ['Pipelines Vision par Ordinateur', 'CNN & Deep Learning', 'PyTorch & OpenCV', 'Intégration IA dans les Apps Web'],
          color: 'from-violet-500 to-purple-600',
        },
      ],
    },
    skills: {
      sectionLabel: 'Expertise Technique',
      headline1: 'Compétences &',
      headline2: 'Technologies',
      subheadline: 'Un ensemble ciblé de technologies pour créer des systèmes intelligents et des applications web complètes.',
      categories: {
        languages: {
          title: 'Langages',
          description: 'Les langages utilisés dans mes projets logiciels, web et IA.',
        },
        ai: {
          title: 'IA & Vision par Ordinateur',
          description: "Conception de pipelines de traitement d’image et de solutions de machine learning, de l’expérimentation à l’évaluation.",
        },
        frontend: {
          title: 'Frontend',
          description: 'Création d’interfaces responsives, accessibles et soignées.',
        },
        backend: {
          title: 'Backend & Données',
          description: 'Développement d’API fiables et de couches de données structurées.',
        },
        tools: {
          title: 'Outils & Workflow',
          description: 'Un environnement pratique pour développer, prototyper et collaborer.',
        },
      },
    },
    education: {
      sectionLabel: 'Formation',
      headline1: 'Parcours',
      headline2: 'Académique',
      current: 'En cours',
      coursework: 'Cours suivis',
    },
    projects: {
      sectionLabel: 'Portfolio',
      headline1: 'Projets',
      headline2: 'Récents',
      subheadline: 'Une sélection de travaux réels — sites clients et systèmes IA',
      liveDemo: 'Démo Live',
      githubRepo: 'Dépôt GitHub',
    },
    community: {
      sectionLabel: 'Communauté & Liens',
      headline1: 'Me',
      headline2: 'Contacter',
      links: [
        { title: 'GitHub', description: 'Découvrez mes projets open-source, contributions et dépôts de code.' },
        { title: 'LinkedIn', description: 'Connectez-vous avec moi professionnellement et consultez mon parcours.' },
        { title: 'Email', description: 'Contactez-moi pour des collaborations, opportunités ou simplement un bonjour.' },
      ],
      visit: 'Visiter',
    },
    contact: {
      sectionLabel: 'Contact',
      headline1: 'Un Projet',
      headline2: 'en Tête ?',
      subheadline: 'Construisons quelque chose de grand ensemble.',
      sideHeadline1: 'Construisons quelque chose de',
      sideHeadline2: 'Grand',
      sideP: "Je suis toujours ouvert à de nouvelles opportunités — collaborations, stages ou postes. Si vous avez un projet ou juste envie d'échanger, n'hésitez pas à me contacter.",
      labelEmail: 'Email',
      labelPhone: 'Téléphone',
      labelLocation: 'Localisation',
      formName: 'Nom',
      formNamePh: 'Votre nom complet',
      formEmail: 'Email',
      formEmailPh: 'votre.email@exemple.com',
      formMessage: 'Message',
      formMessagePh: 'Parlez-moi de votre projet ou opportunité...',
      send: 'Envoyer le message',
      sending: 'Envoi en cours...',
      success: 'Message envoyé avec succès ! Je vous répondrai bientôt.',
      error: "Échec de l'envoi. Réessayez ou contactez-moi directement.",
    },
    footer: {
      copyright: '© 2025 Amine Sellami. Créé avec React & passion.',
    },
  },
};

export default translations;
